// Step 22 — buyer communication + silence card.
//
// Every value here comes directly from `intel.communication` and
// `intel.silence` (from `aggregate_buyer_intelligence`). Silence is a
// FACT-level observation about our own outbox — the backend labels it
// as such; we preserve that framing in the UI.

import { AIEmpty, AISection } from "../AIPrimitives";

function _fmtWhen(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("sv-SE", {
      dateStyle: "short",
      timeStyle: "short",
    });
  } catch {
    return String(iso);
  }
}

export default function AIBuyerActivityCard({ intel, portfolioRow }) {
  const comm = intel?.communication;
  const silence = portfolioRow?.silence;
  if (!comm && !silence) {
    return (
      <AISection title="Aktivitet">
        <AIEmpty title="Ingen kommunikationsdata registrerad." />
      </AISection>
    );
  }

  const rows = [];
  if (comm) {
    rows.push([
      "Skickade utskick",
      String(comm.outbound_count ?? 0),
    ]);
    rows.push([
      "Svar",
      String(comm.inbound_count ?? 0),
    ]);
    if (comm.last_outbound_at) {
      rows.push(["Senaste utskick", _fmtWhen(comm.last_outbound_at)]);
    }
    if (comm.last_inbound_at) {
      rows.push(["Senaste svar", _fmtWhen(comm.last_inbound_at)]);
    }
    if ((comm.bounce_count ?? 0) > 0) {
      rows.push(["Leveransfel", String(comm.bounce_count)]);
    }
  }

  return (
    <AISection title="Aktivitet">
      <dl className="qai-buyer-activity">
        {rows.map(([k, v]) => (
          <div key={k} className="qai-buyer-activity-row">
            <dt>{k}</dt>
            <dd>{v}</dd>
          </div>
        ))}
      </dl>
      {silence?.is_silent && (
        <div className="qai-buyer-silence" role="status">
          <span className="qai-buyer-silence-flag">Tyst</span>
          <span>
            {silence.days_since_last_outbound ?? "?"} dagar sedan senaste utskick
            (tröskel {silence.threshold_days ?? 14} dagar). Detta är en
            deterministisk observation om vår egen utskickskö — inte en
            slutsats om köparens läge.
          </span>
        </div>
      )}
    </AISection>
  );
}
